export const getParameterByName = (name) => {
	const regExp = new RegExp("[?&]" + name + "=([^&]*)", "i");

	const searchParams = window.location.search;
	const decodedSearchParams = decodeURIComponent(window.location.search);

	const match = regExp.exec(searchParams) || regExp.exec(decodedSearchParams);

	return match ? decodeURIComponent(match[1].replace(/\+/g, " ")) : "";
};

export const getBoolParameterByName = (name) =>
	/true/i.test(getParameterByName(name));
